import forEach from '../../../../javascripts/dom/forEach';

const searchheader = document.querySelectorAll('[data-js-module="o-search-header"]');

export default function init() {
  if (searchheader) {
    const loadAsync = async () => {
      const { default: SearchHeader } = await import(
        /* webpackChunkName: "o-header" */ './search-header'
      );

      forEach(searchheader, (index, element) => new SearchHeader(element));
    };

    loadAsync();
  }
}

if (searchheader.length) init();
